import React from "react";
import Header from "../header/Header";
import CustomMenu from "../customMenu/CustomMenu";
import CustomHeaderLogo from "./CustomHeaderLogo";
import * as PropTypes from "prop-types";
import {node} from "prop-types";
import CustomHeaderLogoMedia from "./CustomHeaderLogoMedia";
import {header} from "../../../../constants/copyright";
import styles from "./CustomHeader.module.scss";



export default function CustomHeader(props) {
  const {headings, children} = props;
  const {logoMain, logoMedia} = header;

  return (
    <Header burger={true}
            logo={<CustomHeaderLogo {...logoMain}
                                    className={styles.customHeader__logo_main} />}
            logo2={<CustomHeaderLogoMedia {...logoMedia}
                                          className={styles.customHeader__logo_media}/>}
            menu={<CustomMenu customMenuItems = {headings}/>}>
      {children}
    </Header>
  )
}

CustomHeader.propTypes = {
  menuList: PropTypes.object,
  children: node,
};

